import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { ComponentModule } from '@app/component/component.module';
import { ChangeRequestTableComponent } from '@app/component/entity-table/change-request-table/change-request-table.component';
import { SearchOperator } from '@core/base/objects/search/search-operator.enum';
import { Pagination } from '@core/objects/pagination';
import { EntitySortUtil } from '@core/utils/entity-sort.util';
import { RestSearchUtil } from '@core/utils/rest-search-util';
import { ChangeRequest } from '@shared/change-request/change-request';
import { ChangeRequestApi } from '@shared/change-request/change-request-api.service';
import { ChangeRequestSort } from '@shared/change-request/change-request-sort.util';

@Component({
  selector: 'app-change-request-widget',
  templateUrl: './change-request-widget.component.html',
  styleUrls: ['./change-request-widget.component.scss'],
  imports: [ComponentModule],
})
export class ChangeRequestWidgetComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(ChangeRequestTableComponent)
  tableComponent!: ChangeRequestTableComponent;

  displayedColumns = ['date', 'entityName', 'field', 'originalValue', 'value'];

  rows: ChangeRequest[] = [];

  constructor(private readonly changeRequestApi: ChangeRequestApi) {}

  ngOnInit(): void {
    const filter = RestSearchUtil.createSearchFieldGroup([
      { fieldName: 'status', value: 'REQUESTED', operator: SearchOperator.EQ },
    ]);
    const pagination = new Pagination(0, 100);

    this.changeRequestApi.findByRequest(filter, pagination).subscribe(result => {
      this.rows = result.content.sort(this.getCompareFn({ active: 'createdOn' } as Sort)).reverse();
    });
  }

  sortData($event: Sort): void {
    if ($event.direction === '') {
      this.rows.sort(this.getCompareFn({ active: 'createdOn' } as Sort));
      this.rows.reverse();
    } else {
      this.rows.sort(this.getCompareFn($event));
      if ($event.direction === 'desc') {
        this.rows.reverse();
      }
    }
    this.tableComponent.renderRows();
  }

  private getCompareFn(sortCommand: Sort): (a: ChangeRequest, b: ChangeRequest) => number {
    switch (sortCommand.active) {
      case 'createdOn':
        return (a: ChangeRequest, b: ChangeRequest): number => {
          return EntitySortUtil.byDateValue(a.createdOn, b.createdOn);
        };
      case 'entityName':
        return ChangeRequestSort.byEntity;
      case 'entityField':
        return (a: ChangeRequest, b: ChangeRequest): number => {
          return EntitySortUtil.byStringValue(a.entityField, b.entityField);
        };
      case 'originalValue':
        return ChangeRequestSort.byOriginalValue;
      case 'requestedValue':
        return ChangeRequestSort.byRequestedValue;
      default:
        return () => 0;
    }
  }
}
